exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".draggable[data-v-6f592d4c]{cursor:move}.draggable.is-pointer-down[data-v-6f592d4c]{background:#09f;z-index:2}.draggable.is-dragging[data-v-6f592d4c]{opacity:.7}", ""]);

// exports
